/* eslint-disable no-console */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, FormattedMessage } from 'react-intl';

import Typography from '@quintoandar/cozy-core/Typography';
import ChipChoice from '@quintoandar/cozy-core/ChipChoice';
import Box from '@quintoandar/cozy-core/Box';

import { getMessageByIntlKey } from 'components/DynamicForm/getMessageByIntlKey';

import messages from './messages';

import { CHOICES } from './constants';

export { CHOICES };

export const getSelectedKey = ({ value }) => {
  switch (value) {
    case false:
      return CHOICES.NO;

    case true:
      return CHOICES.YES;

    default:
      return null;
  }
};

export const getItems = ({ intl, value }) => [
  {
    key: CHOICES.YES,
    label: intl.formatMessage(messages.yes),
    name: CHOICES.YES,
    selected: value === true,
  },
  {
    key: CHOICES.NO,
    label: intl.formatMessage(messages.no),
    name: CHOICES.NO,
    selected: value === false,
  },
];

export const ChipBoolean = ({
  intlKey,
  intl,
  value,
  onChange,
  groupName,
  id,
  onValidateItem,
  shouldValidate,
}) => {
  const items = getItems({ intl, id, value });
  const selectedKey = getSelectedKey({ value, id });

  const [valid, setValid] = useState(true);
  const hasValue = Boolean(selectedKey);

  useEffect(() => {
    onValidateItem(hasValue);
  }, [hasValue]);

  useEffect(() => {
    if (shouldValidate && valid !== hasValue) {
      setValid(hasValue);
    }
  }, [shouldValidate, valid, hasValue]);

  return (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      my={2}
    >
      <Box flexGrow={1} mr={2}>
        <Typography>
          {intl.formatMessage(
            getMessageByIntlKey({ availableMessages: messages, intlKey }),
          )}
        </Typography>
        {!valid && (
          <Typography kind="critical">
            <FormattedMessage {...messages.invalid} />
          </Typography>
        )}
      </Box>
      <Box flexShrink={0} mr={-1}>
        <ChipChoice
          type="checkbox"
          groupName={groupName}
          items={items}
          onChange={onChange}
        />
      </Box>
    </Box>
  );
};

ChipBoolean.propTypes = {
  intlKey: PropTypes.string,
  id: PropTypes.string,
  groupName: PropTypes.string,
  intl: PropTypes.object,
  value: PropTypes.bool,
  onChange: PropTypes.func,
  onValidateItem: PropTypes.func,
  shouldValidate: PropTypes.bool,
};

export default injectIntl(ChipBoolean);
